import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { Spinner } from '@wellbeingxltd/fe-lib/components'
import TicketsActions from 'store/models/tickets'

const Thread = ({ ticket }) => {
    const { threads, loadingThreadId, getThreadError } = useSelector(GET_STORE.TICKETS)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!threads[ticket.ticketId]) {
            dispatch(TicketsActions.getThread(ticket.ticketId))
        }
    }, [dispatch, threads, ticket.ticketId])

    return (
        <div className="thread-list">
            {loadingThreadId === ticket.ticketId ? (
                <Spinner color="var(--blue)" />
            ) : getThreadError ? (
                <p className="error">{getThreadError}</p>
            ) : !threads[ticket.ticketId] ? (
                <p>No thread found</p>
            ) : (
                <p>
                    {threads[ticket.ticketId].map((message, index) => {
                        const key = Object.keys(message)[0]
                        return (
                            <div className="module" key={index}>
                                <div className="module-header">
                                    <h2>Message from {key}:</h2>
                                </div>
                                <div className="thread-inner-html" dangerouslySetInnerHTML={{ __html: message[key] }} />
                            </div>
                        )
                    })}
                </p>
            )}
        </div>
    )
}

export default Thread
